<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     充值购物车
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ap-recharge-cart mt-md mb-md">
    <div class="main-body">
      <el-card v-if="!carts.length" v-loading="cartsLoading" class="left" :body-style="{ height: '100%' }" shadow="never">
        <div class="cart-empty">
          <div class="font-8x text-light">
            <span class="iconfont icon-shapping-cart"></span>
          </div>
          <div class="font-2x text-light">购物车为空</div>
          <div class="mt">
            <el-link type="success" icon="el-icon-magic-stick" @click="importAll">导入所有欠费接入点</el-link>
          </div>
          <el-button type="warning" plain size="small" class="mt" @click="cartDOC">了解充值</el-button>
        </div>
      </el-card>

      <el-card v-else v-loading="cartsLoading" class="left" shadow="never">
        <div slot="header" class="flex align-items-center">
          <div class="bd font-lg flex align-items-center">
            <span>购物车共有</span>
            <span class="text-success ml-xs mr-xs mt-xs">{{ carts.length }}</span>
            <span>个接入点</span>
            <el-alert title="多年优惠，续费时长越长，折扣力度越大" type="warning" :closable="false" style="width: 290px;" class="ml"></el-alert>
          </div>
          <div class="ft">
            <el-link :underline="false" icon="el-icon-brush" @click="clearAll">清空</el-link>
          </div>
        </div>
        <el-table :data="carts" class="cart-table" :row-class-name="tableRowClassName">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column min-width="160px" label="接入点编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.simid }}</span>
              <div class="text-muted" style="font-size: 12px;height: 12px;line-height: 12px">{{ scope.row.ap_model }}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120px" label="当前有效期">
            <template slot-scope="scope">
              <span v-if="scope.row.first_activation == 0">{{ '预充' + scope.row.precharge_month / 12 + '年' }}</span>
              <span v-else-if="scope.row.old_expire_day">{{ scope.row.old_expire_day | parseTime('{y}/{m}/{d}') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120px" label="充值后有效期">
            <template slot-scope="scope">
              <span v-if="scope.row.first_activation == 0">{{ '预充' + (scope.row.precharge_month / 12 + scope.row.num) + '年' }}</span>
              <span v-else-if="scope.row.old_expire_day">{{ newDate(scope.row) | parseTime('{y}/{m}/{d}') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" label="单价" align="right">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.price_frippler_face * scope.row.discount_rate | currency }}</span>
                <span class="ml-xs text-muted">/年</span>
              </div>
              <div v-if="scope.row.discount_rate < 1" class="text-muted" style="font-size: 12px;height: 12px;line-height: 12px">
                <s>
                  <span>{{ scope.row.price_frippler_face | currency }}</span>
                  <span class="text-muted">/年</span>
                </s>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120px" align="right">
            <template slot="header" slot-scope="scope">
              <el-dropdown trigger="click" @command="updateRowAll({num: $event})">
                <span class="el-dropdown-link">
                  <span>续费时长</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="year in yearArr" :key="year.year_num + 'year'" :command="year.year_num" :class="year.year_num == activeNum && 'active'">{{ year.year_num }}年</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <div slot-scope="scope" @click="handleClick(scope.row)">
              <el-dropdown trigger="click" @command="updateRow({ num: $event, row: scope.row })">
                <span class="el-dropdown-link">
                  <span>{{ scope.row.num }}年</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="customer-dropdown-menu">
                  <el-dropdown-item
                    v-for="year in yearArr"
                    :key="year.year_num + 'year'"
                    :command="year.year_num"
                    class="customer-dropdown-item"
                    :class="year.year_num == scope.row.num && 'active'"
                  >
                    <div class="flex align-items-center time-option" style="height: 100%;">
                      <div style="width: 80px;" class="text-center">{{ year.year_num }}年</div>
                      <div class="border-left" style="width: 150px;">
                        <span style="font-size: 16px">{{ year.discount_rate < 1 ? '￥' + year.price : '￥' + year.market_price }}</span>
                        <span v-if="year.discount_rate < 1" style="font-size: 12px; text-decoration: line-through;" class="ml-xs text-muted">￥{{ year.market_price }}</span>
                      </div>
                      <div v-if="year.year_num != 0" style="width: 150px;" class="text-orange border-left">{{ year.discount_rate < 1 ? `优惠后￥${year.price / year.year_num}/年` : '无优惠' }}</div>
                      <div v-if="year.recommended" class="recommend">推荐</div>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-table-column>

          <el-table-column min-width="160px" label="数据存储" align="right">
            <template slot="header" slot-scope="scope">
              <el-dropdown trigger="click" @command="updateDssAll({num: $event})">
                <span class="el-dropdown-link">
                  <span>数据存储</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="dsso in dssOptions"
                    :key="dsso.days + 'dsso'"
                    :command="dsso.days"
                    :class="dsso.days == activeDss && 'active'"
                  >{{ dsso.days <= 7 ? '不购买' : `保留${dsso.days}天` }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="updateRow({ dss_days: $event, row: scope.row })">
                <span class="el-dropdown-link">
                  <span v-if="scope.row.dss_market_price">{{ scope.row.dss_market_price | currency }} /</span>
                  {{ scope.row.new_dss_days <= 7 ? '不购买' : `保留${scope.row.new_dss_days}天` }}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="dsso in dssOptions"
                    :key="dsso.days + 'dsso'"
                    :command="dsso.days"
                    :class="dsso.days == scope.row.new_dss_days && 'active'"
                  >{{ dsso.days <= 7 ? '不购买' : `保留${dsso.days}天` }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <el-table-column min-width="120px" label="金额小计" align="right">
            <template slot-scope="scope">
              <span v-if="scope.row.first_activation == 0 && scope.row.new_dss_days < scope.row.old_dss_days" class="text-danger">{{ '不支持降配' }}</span>
              <div
                v-else-if="scope.row.num != 0 || scope.row.new_dss_days > scope.row.old_dss_days"
              >
                <div>
                  {{ (scope.row.dss_market_price + scope.row.num * scope.row.price_frippler_face * scope.row.discount_rate) | currency }}
                </div>
                <div v-if="scope.row.discount_rate < 1" class="text-muted" style="font-size: 12px;height: 12px;line-height: 12px">
                  <s>
                    <span>{{ (scope.row.dss_market_price + scope.row.num * scope.row.price_frippler_face) | currency }}</span>
                  </s>
                </div>
              </div>
              <span v-else-if="scope.row.new_dss_days == scope.row.old_dss_days" class="text-danger">{{ '配置未变更' }}</span>
              <span v-else-if="scope.row.new_dss_days < scope.row.old_dss_days" class="text-danger">{{ '不支持降配' }}</span>
            </template>
          </el-table-column>
          <el-table-column width="60px">
            <template slot-scope="scope">
              <el-link class="hover-show" :underline="false" icon="el-icon-circle-close" @click="deleteRow(scope.row)"></el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="statistics">
          <div class="mt flex statistics-item">
            <div class="mr text-muted">商品总额：</div>
            <div class="text-right" style="padding-right: 70px;width: 150px;">{{ totalFace | currency }}</div>
          </div>
          <div v-if="totalSaved > 0" class="mt-sm statistics-item">
            <div class="mr text-muted">优惠总额：</div>
            <div class="text-right text-danger" style="padding-right: 70px;width: 150px;">-{{ totalSaved | currency }}</div>
          </div>
          <div class="mt-sm statistics-item">
            <div class="mr text-muted">实际金额：</div>
            <div class="text-right text-success" style="padding-right: 70px;width: 150px;">{{ totalAmount | currency }}</div>
          </div>
        </div>
        
      </el-card>

      <el-card v-loading="productsLoading" class="right" shadow="never">
        <div slot="header">
          <span class="font-lg">配置清单</span>
        </div>
        <div class="display-info sm">
          <div v-if="totalSaved > 0">
            <span class="text-warning text-bold">
              <i class="el-icon-present"></i> 大客户折扣
            </span>
          </div>
          <div>
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ product.s_title }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>续订套餐</span>
            </div>
            <div>
              <span class="fixed-width text-muted">接入点数：</span>
              <span>{{ carts.length ? carts.length : '--' }} 个</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ totalUnitPrice | currency }}</span>
            </div>

            <el-divider></el-divider>
          </div>
          <div v-if="dataStoragePrice != 0">
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ '数据存储服务' }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>变更配置</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ dataStoragePrice | currency }}</span>
            </div>
            <el-divider></el-divider>
          </div>

          <div>
            <span class="text-muted">实际费用</span>
          </div>
          <div v-loading="updating">
            <span class="font-3x text-success">{{ totalAmount | currency }}</span>
            <span v-if="totalSaved > 0" class="ml text-warning">节省 {{ totalSaved | currency }}</span>
          </div>
          <el-divider></el-divider>
          <div class="mt">
            <el-button type="primary" style="width: 100%" :disabled="!(carts.length > 0) || updating || danger" @click="submit">立即充值</el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  apCartGetallApi,
  apCartPostApi,
  apCartDeleteApi,
  apCartClearApi,
  apCartExpiredApi,
  apCartSubmitApi,
  dssOptionsApi,
  apCartCalculateApi,
  calculateMultiYearDiscount,
} from "@/api/ap/apRechargeApi";

export default {
  data() {
    return {
      cartsLoading: false,
      productsLoading: false,
      updating: false,
      danger: false,
      carts: [],
      product: {},
      dssOptions: [], // 数据存储选项

      yearArr: [
        { year_num: 0, discount_rate: 1, price: 0, market_price: 0, recommended: 0 },
        { year_num: 1, discount_rate: 1, price: 0, market_price: 0, recommended: 0 },
        { year_num: 2, discount_rate: 1, price: 0, market_price: 0, recommended: 0 },
        { year_num: 3, discount_rate: 1, price: 0, market_price: 0, recommended: 0 },
        { year_num: 4, discount_rate: 1, price: 0, market_price: 0, recommended: 0},
        { year_num: 5, discount_rate: 1, price: 0, market_price: 0, recommended: 0},
        { year_num: 6, discount_rate: 1, price: 0, market_price: 0, recommended: 0},
      ],
      activeNum: null,
      activeDss: null,
    };
  },
  computed: {
    totalNum() {
      return this.carts.reduce((pre, cur) => {
        return pre + cur.num;
      }, 0);
    },
    totalFace() {
      return this.carts.reduce((pre, cur) => {
        return pre + cur.num * cur.price_frippler_face + cur.dss_market_price;
      }, 0);
    },
    totalAmount() {
      return this.carts.reduce((pre, cur) => {
        const discount = cur.discount_rate || 1;
        return (
          pre +
          cur.num * cur.price_frippler_face * discount +
          cur.dss_market_price
        );
      }, 0);
    },
    totalUnitPrice() {
      return this.carts.reduce((pre, cur) => {
        const discount = cur.discount_rate || 1;
        return pre + cur.num * cur.price_frippler_face * discount;
      }, 0);
    },
    dataStoragePrice() {
      return this.carts.reduce((pre, cur) => {
        return pre + cur.dss_market_price;
      }, 0);
    },
    totalSaved() {
      return this.totalFace > 0 && this.totalAmount
        ? this.totalFace - this.totalAmount
        : 0;
    },
  },
  watch: {
    carts(newVal, oldVal) {
      // console.log("newVal, oldVal: ", newVal, oldVal);
      this.danger = false;
      if (
        newVal.some(
          (item) =>
            (item.num == 0 && item.new_dss_days <= item.old_dss_days) ||
            (item.first_activation == 0 &&
              item.new_dss_days < item.old_dss_days)
        )
      ) {
        this.danger = true;
      }
    },
  },
  created() {
    this.fetchCarts();
    this.fetchDssOptions();
  },
  methods: {
    fetchCarts(loading = true) {
      if (loading) this.cartsLoading = true;
      apCartGetallApi().then((res) => {
        this.cartsLoading = false;
        if (res.errno === 0) {
          this.carts = res.data.list;
          this.product = Object.assign({}, res.data.list[0]);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchDssOptions() {
      //获取dss选项
      this.dssOptions = [];
      dssOptionsApi().then((res) => {
        if (!res.errno) {
          this.dssOptions = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    importAll() {
      this.cartsLoading = true;
      apCartExpiredApi().then((res) => {
        if (res.errno === 0) {
          this.$message.success(res.message);
          this.fetchCarts();
        } else {
          this.cartsLoading = false;
          this.$message.error(res.message);
        }
      });
    },
    newDate(row) {
      return row.old_expire_day + 365 * 86400 * row.num;
    },

    updateRowAll({ num }) {
      this.activeNum = num;
      this.updating = true;
      const params = this.carts.map((item) => {
        const obj = {
          cartid: item.cartid,
          simid: item.simid,
          num: num,
          productid: item.productid,
          new_dss_days: item.new_dss_days,
        };
        return obj;
      });
      // console.log("params: ", params);
      this.cartsLoading = true;
      Promise.all([apCartPostApi({ data: params })]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0) {
          this.fetchCarts();
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    updateDssAll({ num }) {
      this.activeDss = num;
      this.updating = true;
      const params = this.carts.map((item) => {
        const obj = {
          cartid: item.cartid,
          simid: item.simid,
          num: item.num,
          productid: item.productid,
          new_dss_days: num,
        };
        return obj;
      });
      this.cartsLoading = true;
      Promise.all([apCartPostApi({ data: params })]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0) {
          this.fetchCarts();
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    handleClick(row) {
      const godid = this.$store.state.godStore.godid;
      const params = {
        godid,
        cartid: row.cartid,
        simid: row.simid,
      };

      calculateMultiYearDiscount(params).then((res) => {
        if(!res.errno) {
          this.yearArr.map((item,index) => {
            item.discount_rate = res.data.precharge_options[index].discount_rate
            item.market_price = res.data.precharge_options[index].market_price
            item.price = res.data.precharge_options[index].price
            item.precharge_month = res.data.precharge_options[index].precharge_month
            item.recommended = res.data.precharge_options[index].recommended ? res.data.precharge_options[index].recommended : 0
            return item
          })
        }
      })
    },

    updateRow({ num, dss_days, row }) {
      // console.log("[ num ] >", num, dss_days, row);
      this.updating = true;
      const params = {
        cartid: row.cartid,
        simid: row.simid,
        num: num || num == 0 ? Number(num) : row.num,
        productid: row.productid,
        new_dss_days:
          dss_days || dss_days === 0 ? Number(dss_days) : row.new_dss_days,
      };
      Promise.all([
        apCartCalculateApi(params),
        apCartPostApi({ data: [params] }),
      ]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0 && res[1].errno === 0) {
          row = Object.assign(row, res[0].data, { num: params.num });
          this.danger = false;
          if (
            this.carts.some(
              (item) =>
                (item.num == 0 && item.new_dss_days <= item.old_dss_days) ||
                (item.first_activation == 0 &&
                  item.new_dss_days < item.old_dss_days)
            )
          ) {
            this.danger = true;
          }
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    deleteRow(row) {
      apCartDeleteApi({ cartids: [row.cartid] }).then((res) => {
        if (res.errno === 0) {
          this.fetchCarts(false);
        } else {
          this.fetchCarts(false);
          this.$message.error(res.message);
        }
      });
    },
    clearAll() {
      this.danger = false;
      this.activeNum = null;
      this.activeDss = null;
      apCartClearApi().then((res) => {
        if (res.errno === 0) {
          this.fetchCarts(false);
        } else {
          this.fetchCarts(false);
          this.$message.error(res.message);
        }
      });
    },
    submit() {
      this.$confirm(
        `即将提交订单，本次充值共计 <span class="font-lg text-success">${this.carts.length}</span> 个接入点，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          type: "success",
        }
      )
        .then(() => {
          const tempData = {
            cartids: this.carts.map((v) => v.cartid),
          };
          apCartSubmitApi(tempData).then((res) => {
            if (!res.errno) {
              this.$message.success("操作成功！");
              this.$router.push({
                path: "/expense/order/cashier",
              });
              localStorage.setItem("__ORDERID__", res.data.orderid);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    cartDOC() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/35");
    },

    tableRowClassName({ row, rowIndex }) {
      // console.log("row, rowIndex: ", row, rowIndex);
      if (
        !(row.num != 0 || row.new_dss_days > row.old_dss_days) ||
        (row.first_activation == 0 && row.new_dss_days < row.old_dss_days)
      ) {
        return "danger-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu__item.active {
  background-color: #e6f9ef;
  color: #07c160;
}
.main-body {
  display: flex;
  .left {
    flex: auto;
    .statistics {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .statistics-item {
        display: flex;
        justify-content: space-between;
      }
    }
    
  }
  .right {
    flex: none;
    width: 360px;
    margin-left: 20px;
  }
}
.cart-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.cart-table {
  width: 100%;
  border-spacing: 0px;
  tbody {
    transition: all 0.2s;
  }
  .cart-tr {
    display: table-row;
    transition: all 0.2s;
    &:hover {
      background-color: #f5f7fa;
    }
    > td {
      padding: 8px 10px;
    }
  }
}
.fixed-width {
  display: inline-block;
  width: 100px;
}
</style>
<style lang="scss">
.el-table .danger-row {
  background: #fad9d9;
}
.customer-dropdown-menu.el-dropdown-menu {
  padding: 10px;
  padding-bottom: 0;
  .customer-dropdown-item.el-dropdown-menu__item {
    width: 380px;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: center;
    border: 1px solid rgba(235, 238, 245, 1);
    margin-bottom: 10px;
    padding: 0;
    &.active {
      border: 1px solid rgba(230, 162, 60, 1);
    }
    .text-orange {
      color: #F0AD4E;
    }
    .border-left {
      border-left: 1px solid rgba(235, 238, 245, 1);
    }
    .time-option {
      position: relative;
      .recommend {
        position: absolute;
        left: -1px;
        top: -1px;
        width: 32px;
        height: 18px;
        line-height: 18px;
        border-radius: 5px 5px 5px 0px;
        background: linear-gradient(91.06deg, rgba(254,167,44,1) 3.04%,rgba(253,120,34,1) 101.6%);
        color: rgba(255, 255, 255, 1);
        font-size: 10px;
        text-align: center;
      }
    }
    
  }
  .flex {
    display: flex;
    &.align-items-center {
      align-items: center;
    }
    .hd,.ft {
      flex: none;
    }
    .bd {
      flex: auto;
    }
  }
}
</style>